





















































































































import TipoNotificacaoSelect from "@/pages/central-notificacoes/components/TipoNotificacaoSelect.vue";
import {
  CentralNotificacoesService,
  Comentario,
  ComentarioDTO,
  FiltroComentariosNotificacao,
} from "@/services/central-notificacao.service";
import DataTable, { TableHeader } from "@/shared/components/data-table.vue";
import { dateTime, substring } from "@/shared/filters";
import { Paginacao } from "@/shared/interface";
import { ServerPageOptions } from "@/shared/utils/datatable";
import { Component, Vue } from "vue-property-decorator";

interface ComentarioDTOWithKey extends ComentarioDTO {
  idComentario: string;
}

@Component({ components: { DataTable, TipoNotificacaoSelect }, filters: { dateTime, substring } })
export default class Comentarios extends Vue {
  filtros: FiltroComentariosNotificacao = {
    idConsultor: null,
    txtPesquisa: "",
    idTipoNotificacao: null,
    dataComentario: null,
    respondido: null,
    idNotificacao: undefined,
    offset: 0,
    limit: 100,
    order: "",
  };
  menuData = false;
  comentarios: Promise<Paginacao<ComentarioDTOWithKey>> | null = null;
  respostaTexto: Record<string, string> = {};
  reacaoEmoji: Record<string | number, string> = { 1: "😞", 2: "😊", 3: "😍" };
  headersComentarios: TableHeader[] = [
    { text: "Data e Hora", value: "dataComentario", width: "150px" },
    { text: "Id do Consultor", value: "idConsultor", width: "100px" },
    { text: "Consultor", value: "nomeConsultor", withAliasValue: 'c.Nome', width: "200px" },
    {
      text: "Título da Notificação",
      value: "tituloNotificacao",
      width: "auto",
      withAliasValue: 'n.Titulo',
    },
    { text: "Comentário", value: "comentario", width: "370px" },
    { text: "Reação", value: "reacao", width: "100px", class: "text-center" },
    { text: "Ações", value: "acoes", sortable: false, width: "120px" },
  ];

  estaLido(item: ComentarioDTO) {
    return !!item.dataLeituraBackoffice;
  }

  async mounted() {
    const idNotificacao = this.$route.query.idNotificacao as string;
    if (idNotificacao) this.filtros.idNotificacao = idNotificacao;
    this.fetchComentarios();
  }

  voltar() {
    if (this.$route.query.origem === "central")
      this.$router.push({ path: "/centralnotificacoes" });
    else this.$router.go(-1);
  }

  async toggleLido(item: Comentario) {
    if (item.resposta) return;
    const novoLido = !item.lido;
    try {
      await CentralNotificacoesService.marcarLido({
        idNotificacao: item.idNotificacao,
        idConsultor: item.idConsultor,
        lido: novoLido,
      });
      item.lido = novoLido;
      // dataLeituraBackoffice pode não existir no objeto (a API omite campos nulos),
      // então $set garante a reatividade ao adicioná-lo.
      this.$set(item, "dataLeituraBackoffice", novoLido ? new Date().toISOString() : null);
    } catch (err) {
      console.error("Erro ao marcar como lido:", err);
    }
  }

  fetchComentarios(pageSpec?: ServerPageOptions) {
    this.comentarios = CentralNotificacoesService.listarComentarios(
      Object.assign({}, this.filtros, pageSpec)
    ).then(
      (dados): Paginacao<ComentarioDTOWithKey> => {
        return {
          ...dados,
          lista: dados.lista.map((item) => Object.assign({ idComentario: item.idNotificacao + "_" + item.idConsultor }, item)),
        };
      }
    );
  }

  async responderComentario(item: Comentario) {
    const texto = this.respostaTexto[item.idComentario!];
    if (!texto) return;

    try {
      await CentralNotificacoesService.responderComentario({
        idNotificacao: item.idNotificacao,
        idConsultor: item.idConsultor,
        resposta: texto,
      });

      item.resposta = texto;
      item.dataResposta = new Date().toISOString();
      item.lido = true;
      this.respostaTexto[item.idComentario!] = "";

    } catch (error) {
      console.error("Erro ao responder comentário:", error);
    }
  }

  limparFiltros() {
    this.filtros = {
      idConsultor: null,
      txtPesquisa: "",
      idTipoNotificacao: null,
      dataComentario: null,
      respondido: null,
      idNotificacao: this.filtros.idNotificacao || undefined,
      offset: 0,
      limit: 100,
      order: "",
    };
    this.fetchComentarios();
  }
}
